import { useState } from 'react'
import styled from 'styled-components'

import TitleCaption from '@/app/components/TitleCaption'
import TitleHeader from '@/app/components/TitleHeader'
import TwitterLink from '@/app/components/TwitterLink'
import { spaces } from '@/config/global-parameters'

import { IGanador } from '../../consejeros/types/ganadores'
import ICandidato from '../../types/ICandidato'
import CircumscriptionTable from './CircumscriptionTable'
import SearchFilterBase from './SearchFilter'

interface ICircumpscriptionSection {
  className?: string
  candidatos: ICandidato[]
  ganadores: IGanador[]
}

const CircumpscriptionSection = ({
  candidatos,
  className,
  ganadores,
}: ICircumpscriptionSection) => {
  const [inputFilter, setInputFilter] = useState('')
  const [selectedUnit, setSelectedUnit] = useState('porcentaje')

  const changeSelectedUnit = () => {
    setSelectedUnit(selectedUnit === 'porcentaje' ? 'cantidad' : 'porcentaje')
  }

  return (
    <Wrapper className={className}>
      <Top>
        <TitleHeader>Resultados por Circunscripción</TitleHeader>
        <TitleCaption>
          Porcentaje de resultados por circunscripción ordenados de norte a sur
        </TitleCaption>
        <TwitterLink />
      </Top>
      <Results>
        <SearchFilter
          changeSelectedUnit={changeSelectedUnit}
          onChangeInputFilter={setInputFilter}
          selectedUnit={selectedUnit}
        />
        <CircumscriptionTable
          candidatos={candidatos}
          ganadores={ganadores}
          inputFilter={inputFilter}
          selectedUnit={selectedUnit}
        />
      </Results>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: ${spaces.m} 0;
`

const Results = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1px;
`

const Top = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  flex-direction: column;
  gap: ${spaces.xxs};
`

const SearchFilter = styled(SearchFilterBase)`
  margin-bottom: ${spaces.s};
`

export default CircumpscriptionSection
